import axios from "axios";
import config from "./config";
import EntityApi from "./EntityApi";

const RequestApi = {

    STATUS_SUCCESS: 'success',
    STATUS_FAIL: 'fail',

    put: async (url, fields) => {

        const uri = config.host + '/api/' + url;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const data = JSON.stringify(fields);
            const response = await axios.put(uri, data, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to put RequestApi [' + uri + '] - ' + ': fields ' + fields);
        }

    },

    post: async (url, fields) => {

        const uri = config.host + '/api/' + url;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const data = JSON.stringify(fields);
            const response = await axios.post(uri, data, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to post RequestApi [' + uri + '] - ' + ': fields ' + fields);
        }

    },

    get: async (url, params = {}) => {
        let uri = config.host + '/api/' + url;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            let paramsString = new URLSearchParams(params).toString();
            if (paramsString) {
                uri += '?' + paramsString;
            }
            const response = await axios.get(uri, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to post RequestApi [' + uri + ']');
        }
    }

}


export default RequestApi;
